import { Card, Container, Stack, SxProps, Theme, Typography } from '@mui/material';
import { Logo } from '../../components/Logo';
import { LoginButton, SignupButton } from '../../modules';

export const Login = () => {
  return (
    <Container sx={containerStyles}>
      <Card variant={'outlined'} sx={cardStyles}>
        <Stack direction={'column'} spacing={8}>
          <Stack textAlign={'center'} spacing={1}>
            <Typography variant={'h5'}>Vítejte v</Typography>
            <Logo />
            <Typography pt={2}>Pro použití aplikace se prosím přihlašte</Typography>
          </Stack>
          <Stack direction={'column'} spacing={2}>
            <LoginButton fullWidth />
            <Typography pt={6} textAlign={'center'} variant={'body2'} color={'secondary.300'}>
              Nemáte zatím účet?
            </Typography>
            <SignupButton variant={'outlined'} fullWidth />
          </Stack>
        </Stack>
      </Card>
    </Container>
  );
};

const containerStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  gap: 4,
};
const cardStyles: SxProps<Theme> = (theme) => ({
  padding: 4,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '60%',
  },
  [theme.breakpoints.up('md')]: {
    width: '40%',
  },
  mb: '15%',
});
